import BaseDecorator from "./BaseDecorator";
import AttachmentDecorator from "./AttachmentDecorator";
import CompanyDecorator from "./CompanyDecorator";
import ProductDecorator from "./ProductDecorator";
import ProductVariantFullDecorator from "./ProductVariantFullDecorator";
import ProductOrderFieldDecorator from "./ProductOrderFieldDecorator";
import ProductLocationDecorator from "./ProductLocationDecorator";

export default class ProductFullDecorator extends ProductDecorator {
  constructor(...args) {
    super(...args);
    this.normalize();
  }

  transformData({ name, main_image, ...data }) {
    return {
      ...data,
      deprecated_v1_location_alternative_map_content: data.deprecated_v1_location_alternative_map_content || null,

      product_images: data.product_images
        .map((x) => new AttachmentDecorator(x))
        .sort((a, b) => a.position - b.position),

      company: new CompanyDecorator(data.company),

      translations: data.translations
        .map(
          (t) =>
            new BaseDecorator({
              ...t,
              name: t.name || null,
              slug: t.slug || null,
              deprecated_v1_short_description: t.deprecated_v1_short_description || null,
              highlights: t.highlights && t.highlights.length ? t.highlights : [],
              customer_hints: t.customer_hints && t.customer_hints.length ? t.customer_hints : [],
            })
        )
        // Oldest translations first
        .sort((a, b) => (a.id && b.id ? a.id - b.id : 0)),

      product_variants: data.product_variants
        .map((x) => new ProductVariantFullDecorator(x))
        .sort((a, b) => a.position - b.position),

      product_order_fields: data.product_order_fields
        .map((x) => new ProductOrderFieldDecorator(x))
        .sort((a, b) => a.position - b.position),

      product_locations: data.product_locations
        .map((x) => new ProductLocationDecorator(x))
        .sort((a, b) => a.position - b.position),
    };
  }

  normalize() {
    this.priced_fields.forEach((field) => {
      if (field.has_pricing && field.price && field.price.currency !== this.price_currency) {
        field.price_included_in_order_base_amount = false;
      }
    });
  }

  get available_locales() {
    return this.translations.map((t) => t.locale);
  }

  get default_locale() {
    if (this.available_locales.indexOf(I18n.locale) !== -1) {
      return I18n.locale;
    } else if (this.available_locales.indexOf("en") !== -1) {
      return "en";
    } else {
      return this.translations[0] ? this.translations[0].locale : I18n.locale;
    }
  }

  get translation() {
    return (
      this.translations.find((t) => t.locale === this.default_locale) || {
        uuid: "es",
        locale: "es",
      }
    );
  }

  get name() {
    return this.translation && this.translation.name;
  }

  get priced_fields() {
    return this.product_order_fields.filter((field) => field.has_pricing);
  }
  set priced_fields(priced_fields) {
    this.product_order_fields = this.customer_fields.concat(
      priced_fields.map((x) => new ProductOrderFieldDecorator(x))
    );
  }

  get customer_fields() {
    return this.product_order_fields.filter((field) => !field.has_pricing);
  }
  set customer_fields(customer_fields) {
    this.product_order_fields = this.priced_fields.concat(
      customer_fields.map((x) => new ProductOrderFieldDecorator(x))
    );
  }

  get main_image() {
    return this.product_images && this.product_images.find((at) => at.type === "Attachment::File");
  }

  get pickup_points_assignation_type() {
    return this.product_variants[0].pickup_points_assignation_type;
  }

  set pickup_points_assignation_type(pickup_points_assignation_type) {
    this.product_variants = this.product_variants
      .map(
        (pv) =>
          new ProductVariantFullDecorator({
            ...pv,
            pickup_points_assignation_type,
          })
      )
      .sort((a, b) => a.position - b.position);
  }

  get pickup_points_price_type() {
    return this.product_variants[0].pickup_points_price_type;
  }

  set pickup_points_price_type(pickup_points_price_type) {
    this.product_variants = this.product_variants
      .map((pv) => new ProductVariantFullDecorator({ ...pv, pickup_points_price_type }))
      .sort((a, b) => a.position - b.position);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductFullDecorator.js